export default "__VITE_ASSET__BKgSBKea__"